import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "table__headers" }
const _hoisted_2 = { class: "table__title text--md" }
const _hoisted_3 = {
  key: 0,
  class: "table__actions"
}
const _hoisted_4 = { class: "table__content" }
const _hoisted_5 = {
  key: 0,
  class: "table__header"
}
const _hoisted_6 = { class: "table__row table__row--header" }
const _hoisted_7 = {
  key: 1,
  class: "text-body--md text--medium uppercase"
}
const _hoisted_8 = {
  key: 1,
  class: "table__body"
}
const _hoisted_9 = {
  key: 0,
  class: "table__cell"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 0,
  class: "table__cell"
}
const _hoisted_12 = {
  key: 0,
  class: "table__message"
}
const _hoisted_13 = {
  key: 0,
  class: "table__loading"
}
const _hoisted_14 = {
  key: 1,
  class: "table__empty"
}
const _hoisted_15 = {
  key: 1,
  class: "table__footer"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("span", null, "paginator", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", {
    class: ["table", [{'table--compact': _ctx.compact}, 'table--' + _ctx.size]]
  }, [
    _createVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "table.headers", {}, () => [
        _createVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
        (_ctx.filter || _ctx.$slots['table.headers.actions'])
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "table.headers.actions", {}, () => [
                _createVNode(_component_InputText, {
                  prependIcon: "search",
                  modelValue: _ctx.search,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.search = $event)),
                  search: ""
                }, null, 8, ["modelValue"])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("table", {
        class: ["table__table", {'table__table--compact': _ctx.compact}]
      }, [
        (_ctx.headers)
          ? (_openBlock(), _createBlock("thead", _hoisted_5, [
              _createVNode("tr", _hoisted_6, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.headers, (header) => {
                  return (_openBlock(), _createBlock("th", {
                    class: "table__cell table__cell--header",
                    key: header.id,
                    scope: "col"
                  }, [
                    _createVNode("div", {
                      class: ["table__cell--vcenter", ['table__cell--' + header.align]]
                    }, [
                      _renderSlot(_ctx.$slots, 'table.header.' + header.id, { header: header }, () => [
                        (header.sortKey)
                          ? (_openBlock(), _createBlock(_component_Button, {
                              key: 0,
                              class: "text-body--md text--medium uppercase",
                              text: header.title,
                              icon: _ctx.sortIconByheader(header.sortKey),
                              size: "sm",
                              theme: "text",
                              onClicked: ($event: any) => (_ctx.setSortKey(header.sortKey)),
                              reverseOrder: ""
                            }, null, 8, ["text", "icon", "onClicked"]))
                          : (_openBlock(), _createBlock("span", _hoisted_7, _toDisplayString(header.title), 1))
                      ])
                    ], 2)
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.fiteredItems)
          ? (_openBlock(), _createBlock("tbody", _hoisted_8, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.fiteredItems, (item, ind) => {
                return (_openBlock(), _createBlock("tr", {
                  class: "table__row",
                  key: ind
                }, [
                  _renderSlot(_ctx.$slots, "table.item.prepend.custom", { item: item }, () => [
                    (_ctx.$slots['table.item.prepend'])
                      ? (_openBlock(), _createBlock("td", _hoisted_9, [
                          _renderSlot(_ctx.$slots, "table.item.prepend", { item: item })
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.headers)
                    ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.headers, (column) => {
                        return _renderSlot(_ctx.$slots, 'table.item.custom.'+column.id, {
                          item: item,
                          value: column.itemKey ? item[column.itemKey] : undefined,
                          field: column.id,
                          classes: ['table__cell', {'table__cell--primary': column.primary, 'table__cell--compact': column.compact, 'table__cell--wrap': column.wrap}, 'table__cell--' + column.align]
                        }, () => [
                          _createVNode("td", {
                            class: ["table__cell", [{'table__cell--primary': column.primary, 'table__cell--compact': column.compact, 'table__cell--wrap': column.wrap}, 'table__cell--' + column.align]],
                            "data-label": column.title
                          }, [
                            _renderSlot(_ctx.$slots, 'table.item.'+column.id, {
                              item: item,
                              value: column.itemKey ? item[column.itemKey] : undefined
                            }, () => [
                              (column.itemKey)
                                ? (_openBlock(), _createBlock("span", _hoisted_10, _toDisplayString(item[column.itemKey]), 1))
                                : _createCommentVNode("", true)
                            ])
                          ], 10, ["data-label"])
                        ])
                      }), 256))
                    : (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(item, (value, field, i) => {
                        return _renderSlot(_ctx.$slots, 'table.item.custom.' + field.toString, {
                          key: field.toString+i,
                          item: item,
                          value: value,
                          field: field
                        }, () => [
                          _createVNode("td", {
                            class: "table__cell",
                            "data-label": field
                          }, [
                            _renderSlot(_ctx.$slots, 'table.item.' + field.toString, {
                              item: item,
                              value: value
                            }, () => [
                              _createVNode("span", null, _toDisplayString(value), 1)
                            ])
                          ], 8, ["data-label"])
                        ])
                      }), 128)),
                  _renderSlot(_ctx.$slots, "table.item.append.custom", { item: item }, () => [
                    (_ctx.$slots['table.item.append'])
                      ? (_openBlock(), _createBlock("td", _hoisted_11, [
                          _renderSlot(_ctx.$slots, "table.item.append", { item: item })
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    (!_ctx.fiteredItems.length || _ctx.loading)
      ? (_openBlock(), _createBlock("div", _hoisted_12, [
          (_ctx.loading)
            ? (_openBlock(), _createBlock("div", _hoisted_13, _toDisplayString(_ctx.loadingText), 1))
            : (_openBlock(), _createBlock("div", _hoisted_14, _toDisplayString(_ctx.emptyText), 1))
        ]))
      : _createCommentVNode("", true),
    (_ctx.paginator || _ctx.$slots['table.footer'])
      ? (_openBlock(), _createBlock("div", _hoisted_15, [
          _renderSlot(_ctx.$slots, "table.footer", {}, () => [
            _hoisted_16
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}